
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";

export default function AlibaugLanding() {
  return (
    <>
    <CommonLanding
      title="Explore Alibaug & Elephanta in Style"
      subtitle="Fast, private, luxurious travel"
      heading="Skip Traffic. Sail Instead."
      text="Reach Alibaug in 20 minutes or explore Elephanta with guided tours."
      image="https://images.unsplash.com/photo-1501785888041-af3ef285b470"
      ctaText="Book Tour"
      schema={{
        "@context": "https://schema.org/",
        "@type": "TouristTrip",
        "name": "Alibaug Speedboat Tour"
      }}
      features={[
        { title: "Fast Travel", desc: "Quickest route." },
        { title: "Guided Tours", desc: "Historical insights." },
        { title: "VIP Experience", desc: "Private boarding." }
      ]}
    />
      <Header />

      <section className="ib-bday-wrapper">
        <div className="ib-bday-hero">
          <h1 className="ib-bday-title">
            Explore Alibaug & Elephanta in Style
          </h1>
          <p className="ib-bday-subtitle">
            Fast, private, and luxurious travel.
          </p>
        </div>

        <div className="ib-bday-section">
          <h2 className="ib-bday-heading">
            Skip Traffic. Sail Instead.
          </h2>
          <p className="ib-bday-text">
            Reach Alibaug in 20 minutes or explore Elephanta with guided tours.
          </p>
        </div>

        <div className="ib-bday-feature-grid">
          <div className="ib-bday-card">
            <h3>Fast Travel</h3>
            <p>Quickest route to Mandwa.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Guided Tours</h3>
            <p>Historical insights included.</p>
          </div>

          <div className="ib-bday-card">
            <h3>VIP Experience</h3>
            <p>Private boarding and service.</p>
          </div>
        </div>

        <div className="ib-bday-cta">
          <a href="/contact" className="ib-bday-btn">
            Book Tour
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}
